import CoinList from "../../CoinList/CoinList";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { RangeDatePicker } from "jalali-react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { getUserTransactions } from "../../../../actions/user";
import { LoadingPage } from "../../../LoadingPage/LoadingPage";
import { getSignedAmount } from "../../../../utils/getSignedAmount";
import { errorMessage } from "../../../../utils/messages";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../../actions/loadingPage";
import { isEmpty } from "lodash";
import moment from "jalali-moment";
//ICON
import styles from "./Transactions.module.scss";
import SellIcon from "../../../../styles/icon/Trans_sell.svg";
import ConvertIcon from "../../../../styles/icon/trans_convert.svg";
import BuyIcon from "../../../../styles/icon/trans_buy.svg";
import ArrowIcon from "../../../../styles/icon/arrow_wallet.svg";
import WithdrawIcon from "../../../../styles/icon/trans_withdraw.svg";
import DepositIcon from "../../../../styles/icon/trans_deposit.svg";
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import commissionIcon from "../../../../styles/icon/commission.svg";

export default function Transactions() {
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const transactions = useSelector(
    (state) => state.fullUserInfo.userTransactions
  );
  let [userTransactionsDetails, setUserTransactionsDetails] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    const getTransactionList = async () => {
      try {
        dispatch(showLoadingPage());
        await dispatch(getUserTransactions());
      } catch (ex) {
        errorMessage("خطایی رخ داد!");
      } finally {
        dispatch(hiddenLoadingPage());
      }
    };
    getTransactionList();
  }, []);
  useEffect(() => {
    if (!isEmpty(transactions))
      setUserTransactionsDetails(
        filterTransaction.type && filterTransaction.type !== "WTH-DEP"
          ? transactions?.filter((e) => e.operation === filterTransaction.type)
          : filterTransaction.type === "WTH-DEP"
          ? transactions?.filter(
              (e) => e.operation === "DEPOSIT" || e.operation === "WITHDRAW"
            )
          : transactions
      );
  }, [transactions]);
  //// State's
  const [filterTransaction, setFilterTransaction] = useState({
    symbol: "",
    faName: "",
    type: "",
    startDate: "",
    endDate: "",
  });
  //
  useEffect(() => {
    setUserTransactionsDetails(
      transactions?.filter(
        (tx) =>
          (filterTransaction.type
            ? tx.operation === filterTransaction.type
            : tx) &&
          (filterTransaction.symbol
            ? tx.coinName === filterTransaction.symbol
            : tx) &&
          (filterTransaction.startDate
            ? tx.createdAt > filterTransaction.startDate
            : tx) &&
          (filterTransaction.endDate
            ? tx.createdAt < filterTransaction.endDate
            : tx)
      )
    );
    if (filterTransaction.type === "CHANGE" && filterTransaction.faName) {
      setUserTransactionsDetails(
        transactions?.filter(
          (tx) =>
            (filterTransaction.symbol
              ? tx.faName === filterTransaction.faName
              : tx) &&
            (filterTransaction.startDate
              ? tx.createdAt > filterTransaction.startDate
              : tx) &&
            (filterTransaction.endDate
              ? tx.createdAt < filterTransaction.endDate
              : tx)
        )
      );
    }
  }, [filterTransaction]);
  //SHOW And Hidden Menus
  const [showCoinListMenu, setShowCoinListMenu] = useState(false);
  const [showTypeTransaction, setShowTypeTransaction] = useState(false);
  const history = useHistory();
  //End Show and Hidden Menus
  //Start -Filter Information from another components (With Params)
  const queryParams = new URLSearchParams(window.location.search);
  const getParams = queryParams.get("f");
  // END -Filter Information from another components (With Params)
  useEffect(() => {
    if (getParams) {
      setFilterTransaction({
        ...filterTransaction,
        type: getParams.toUpperCase(),
      });
    }
  }, [getParams]);

  function changeDateFromJalaliToMiladi(value) {
    let sd = value.start._i;
    let ed = value.end._i;
    sd = sd.replace("-//", "") + " 00:00:00";
    ed = ed.replace("-//", "") + " 00:00:00";

    setFilterTransaction({
      ...filterTransaction,
      endDate: ed,
      startDate: sd,
    });
  }
  ////
  ////
  //Show Better and Right History
  const txStatus = [
    { value: "BUY", label: "خرید" },
    { value: "SELL", label: "فروش" },
    { value: "CHANGE", label: "تبدیل" },
    { value: "DEPOSIT", label: "واریز" },
    { value: "WITHDRAW", label: "برداشت" },
    { value: "PAY", label: "درگاه" },
    { value: "COMMISSION", label: "کمیسیون" },
  ];

  if (showCoinListMenu) {
    return (
      <CoinList
        visible={showCoinListMenu}
        setVisible={setShowCoinListMenu}
        currentCoin={filterTransaction}
        setCurrentCoin={setFilterTransaction}
      />
    );
  }
  return (
    <>
      {loadingBar && <LoadingPage />}
      <div>
        <div
          className={`${styles.bg_choice_trans} ${
            showTypeTransaction ? styles.blockDis : styles.nonDis
          }`}
          onClick={() => setShowTypeTransaction(false)}
        ></div>
        <div
          className={`${styles.menu_choice_trans} ${
            showTypeTransaction ? styles.showWithAnim : styles.visibleWithAnim
          }`}
        >
          <div className={styles.top_items}>
            <div
              className={styles.item_of_trans}
              onClick={() => {
                setFilterTransaction({ ...filterTransaction, type: "BUY" });
                setShowTypeTransaction(false);
              }}
            >
              <div>
                <img src={BuyIcon} alt="BUY" width={30} height={30} />
              </div>
              <div>خرید</div>
            </div>
            <div
              className={styles.item_of_trans}
              onClick={() => {
                setFilterTransaction({ ...filterTransaction, type: "SELL" });
                setShowTypeTransaction(false);
              }}
            >
              <div>
                <img src={SellIcon} alt="SELL" width={30} height={30} />
              </div>
              <div>فروش</div>
            </div>
            <div
              className={styles.item_of_trans}
              onClick={() => {
                setFilterTransaction({ ...filterTransaction, type: "CHANGE" });
                setShowTypeTransaction(false);
              }}
            >
              <div>
                <img src={ConvertIcon} alt="CONVERT" width={30} height={30} />
              </div>
              <div>تبدیل</div>
            </div>
          </div>
          <div className={styles.bottom_items}>
            <div
              className={styles.item_of_trans}
              onClick={() => {
                setFilterTransaction({ ...filterTransaction, type: "DEPOSIT" });
                setShowTypeTransaction(false);
              }}
            >
              <div>
                <img
                  src={DepositIcon}
                  alt="DEPOSIT"
                  width={60}
                  height={60}
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-21px",
                  }}
                />
              </div>
              <div>واریز</div>
            </div>

            <div
              className={styles.item_of_trans}
              onClick={() => {
                setFilterTransaction({
                  ...filterTransaction,
                  symbol: "",
                  faName: "",
                  type: "COMMISSION",
                });
                setShowTypeTransaction(false);
              }}
            >
              <div>
                <img
                  src={commissionIcon}
                  alt="COMMISsION"
                  width={35}
                  height={35}
                />
              </div>
              <div>کمیسیون</div>
            </div>

            <div
              className={styles.item_of_trans}
              onClick={() => {
                setFilterTransaction({
                  ...filterTransaction,
                  type: "WITHDRAW",
                });
                setShowTypeTransaction(false);
              }}
            >
              <div>
                <img
                  src={WithdrawIcon}
                  alt="WITHDRAW"
                  width={60}
                  height={60}
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-17px",
                  }}
                />
              </div>
              <div>برداشت</div>
            </div>
          </div>
        </div>
      </div>
      {/*Top Code Choice Filter For Transaction  */}

      <div className={styles.container}>
        <div className={styles.back_btn}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
            className="convertPicToWhite"
          />
        </div>
        <div className={`font_color_white ${styles.title_of_page}`}>
          تراکنش ها
        </div>
        <div className={styles.choice_coin_for_filter_container}>
          <input
            className="changeBackgroundToWhite changeFontColorToBlack"
            type="text"
            readOnly
            placeholder="انتخاب ارز"
            onClick={() => setShowCoinListMenu(true)}
            value={filterTransaction.faName}
            disabled={filterTransaction.type === "COMMISSION"}
          />
          <div className={styles.arrow_pic_container}>
            <img src={ArrowIcon} alt="" width={15} height={15} />
          </div>
        </div>
        <div className={styles.history_place_container}>
          <div className={styles.title_of_pick_date}>تاریخ</div>
          <div className={styles.date_pick}>
            <div className={styles.dataPicker}>
              <RangeDatePicker
                fromLabel="از:"
                toLabel="تا: "
                onClickSubmitButton={changeDateFromJalaliToMiladi}
              />
            </div>
          </div>
        </div>
        <div className={styles.transactions_kind}>
          <input
            className="changeBackgroundToWhite changeFontColorToBlack"
            type="text"
            readOnly
            placeholder="نوع تراکنش"
            onClick={() => setShowTypeTransaction(true)}
            value={
              filterTransaction.type === "BUY"
                ? "خرید"
                : filterTransaction.type === "SELL"
                ? "فروش"
                : filterTransaction.type === "CHANGE"
                ? "تبدیل"
                : filterTransaction.type === "DEPOSIT"
                ? "واریز"
                : filterTransaction.type === "WITHDRAW"
                ? "برداشت"
                : filterTransaction.type === "WTH-DEP"
                ? "واریز و برداشت"
                : filterTransaction.type === "COMMISSION"
                ? "کمیسیون"
                : ""
            }
          />
          <div className={styles.arrow_pic_container}>
            <img src={ArrowIcon} alt="" width={15} height={15} />
          </div>
        </div>
        <div className={styles.transactions_user_container}>
          {userTransactionsDetails &&
            userTransactionsDetails.map((transaction) => {
              const isChange =
                transaction.operation === "CHANGE" ? true : false;
              const irt = transaction.coinName === "IRT" ? true : false;
              return (
                <div
                  className={`changeBackgroundToWhite  ${styles.transaction_container}`}
                  key={
                    transaction.createdAt + new Date() + Math.random() * 10000
                  }
                >
                  <div
                    className={`changeFontColorToBlack ${styles.item_in_info_transaction}`}
                  >
                    <div>تاریخ</div>
                    <div>
                      {moment(transaction.createdAt, "YYYY-MM-DDThh:mm:ss.000Z")
                        .locale("fa")
                        .format("hh:mm:ss YYYY/MM/DD")}
                    </div>
                    <div className={styles.pic_of_polygon}></div>
                  </div>
                  <div
                    className={`changeFontColorToBlack ${styles.item_in_info_transaction}`}
                  >
                    <div>نام ارز</div>
                    <div>
                      {!isChange
                        ? transaction.coin.faName
                        : transaction.coinName}
                    </div>
                    <div className={styles.pic_of_polygon2}></div>
                  </div>
                  <div
                    className={`changeFontColorToBlack ${styles.item_in_info_transaction}`}
                  >
                    <div>مقدار</div>
                    <div>
                      {getSignedAmount(
                        transaction.amount,
                        transaction.operation,
                        irt
                      )}
                    </div>
                    <div className={styles.pic_of_polygon2}></div>
                  </div>
                  <div
                    className={`changeFontColorToBlack ${styles.item_in_info_transaction}`}
                  >
                    <div>عملیات</div>
                    <div>
                      {
                        txStatus.filter(
                          (st) => st.value === transaction.operation
                        )[0].label
                      }
                    </div>
                    <div className={styles.pic_of_polygon2}></div>
                  </div>
                  {isChange ? (
                    <div
                      className={`changeFontColorToBlack ${styles.item_in_info_transaction}`}
                    >
                      <div>قیمت واحد</div>
                      <div>{transaction.price.replace(/\.?0+$/, "")}</div>
                      <div className={styles.pic_of_polygon2}></div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className={`changeFontColorToBlack ${styles.item_in_info_transaction}`}
                  >
                    <div>{isChange ? "کل" : "موجودی"}</div>
                    <div>
                      {irt && !isChange
                        ? parseInt(transaction?.balance).toLocaleString()
                        : transaction?.balance?.replace(/\.?0+$/, "")}
                      {isChange
                        ? transaction.totalPrice
                            .toString()
                            .replace(/\.?0+$/, "")
                        : ""}
                    </div>
                    <div className={styles.pic_of_polygon2}></div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}
